export default __webpack_public_path__ + "static/media/removeMember.d8a6142e.svg";